import { makeStyles, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { styles } from './page.styles';

export interface PageRightColumnProps {
  title?: string | undefined;
}

const PageRightColumn: React.FC<PageRightColumnProps> = ({ title, ...props }) => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <div className={classes.rightColumn}>
      {title && (
        <div className={classes.columnHeader}>
          <Typography variant="h1" color="secondary">
            {title}
          </Typography>
        </div>
      )}

      {props.children}
    </div>
  );
};

export default PageRightColumn;
